/**
 * Device detection utilities
 */

import React from 'react';

/**
 * Check if the device is mobile based on screen size
 * @returns true if mobile device (screen width <= 991px)
 */
export const isMobile = (): boolean => {
  return window.innerWidth <= 991;
};

/**
 * Check if the device is tablet based on screen size
 * @returns true if tablet device (screen width between 768px and 991px)
 */
export const isTablet = (): boolean => {
  const width = window.innerWidth;
  return width >= 768 && width <= 991;
};

/**
 * Check if the device is desktop based on screen size
 * @returns true if desktop device (screen width > 991px)
 */
export const isDesktop = (): boolean => {
  return window.innerWidth > 991;
};

/**
 * React hook to track mobile state with window resize listener
 * @returns current mobile state
 */
export const useMobileDetection = (): boolean => {
  const [mobile, setMobile] = React.useState(isMobile());

  React.useEffect(() => {
    const handleResize = () => {
      setMobile(isMobile());
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return mobile;
};